import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_TOTEM } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Totem',
        name: 'Totem',
        icon: 'fas fa-video',
        route: { name: ROUTE_NAME_TOTEM }
    }
]);

export default registerRouteForModule(router);
